import { render, staticRenderFns } from "./Sv2Editor.vue?vue&type=template&id=f73c1f60&scoped=true&"
import script from "./Sv2Editor.vue?vue&type=script&lang=js&"
export * from "./Sv2Editor.vue?vue&type=script&lang=js&"
import style0 from "./Sv2Editor.vue?vue&type=style&index=0&id=f73c1f60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73c1f60",
  null
  
)

export default component.exports